var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.8332H11.1667V10.5415H12.8333V12.8332H14.5V8.87484L12 7.20817L9.5 8.87484V12.8332ZM12 19.7707C11.8056 19.7707 11.6111 19.736 11.4167 19.6665C11.2222 19.5971 11.0486 19.4929 10.8958 19.354C9.99305 18.5207 9.19444 17.7082 8.5 16.9165C7.80555 16.1248 7.22569 15.3575 6.76042 14.6144C6.29514 13.8714 5.94097 13.1561 5.69792 12.4686C5.45486 11.7811 5.33333 11.1248 5.33333 10.4998C5.33333 8.4165 6.00347 6.75678 7.34375 5.52067C8.68403 4.28456 10.2361 3.6665 12 3.6665C13.7639 3.6665 15.316 4.28456 16.6562 5.52067C17.9965 6.75678 18.6667 8.4165 18.6667 10.4998C18.6667 11.1248 18.5451 11.7811 18.3021 12.4686C18.059 13.1561 17.7049 13.8714 17.2396 14.6144C16.7743 15.3575 16.1944 16.1248 15.5 16.9165C14.8056 17.7082 14.0069 18.5207 13.1042 19.354C12.9514 19.4929 12.7778 19.5971 12.5833 19.6665C12.3889 19.736 12.1944 19.7707 12 19.7707Z",
    fill: "#5CE1E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.d0ba2fd5c2d56c0f11a6dd843c6703c5.svg";
export { ForwardRef as ReactComponent };